import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetDashboardStatsService = () => {
  return HTTP_CLIENT.get(Endpoint.dashboard.stats);
};

const GetGraphStatsService = (payload: { year: string }) => {
  return HTTP_CLIENT.get(
    Endpoint.dashboard.graphStats + `?year=${payload.year}`
  );
};

const GetNewOrganizationsService = (payload: { count: string }) => {
  return HTTP_CLIENT.get(
    Endpoint.dashboard.newOrganizationsStats + `?count=${payload.count}`
  );
};

const GetOrganizationsStatsService = () => {
  return HTTP_CLIENT.get(Endpoint.dashboard.organizationsStats);
};

export {
  GetDashboardStatsService,
  GetGraphStatsService,
  GetNewOrganizationsService,
  GetOrganizationsStatsService,
};
